export default __webpack_public_path__ + "static/media/pic4.9f7d3518.jpg";